export const contactInfo = [
  { heading: "First name", placeholder: "John" },
  { heading: "Last Name", placeholder: "Watson" },
  { heading: "Company", placeholder: "" },
  { heading: "Phone Number", placeholder: "" },
  { heading: "Fax", placeholder: "" },
];

export const addressFields = [
  { heading: "Street Address", placeholder: "" },
  { heading: "Country", placeholder: "" },
  { heading: "State/Province", placeholder: "" },
  { heading: "Zip/Postal Code", placeholder: "" },
];
export const accountInfo = [
  { heading: "First name", placeholder: "John" },
  { heading: "Last Name", placeholder: "Watson" },
];
export const shippingAddress = [
  { heading: "Email Address", placeholder: "" },
  { heading: "Password", placeholder: "" },
  { heading: "Zip/Postal Code", placeholder: "" },
  { heading: "First Name", placeholder: "" },
  { heading: "Last Name", placeholder: "" },
  { heading: "Company", placeholder: "" },
  { heading: "Street Address", placeholder: "" },
  { heading: "Country", placeholder: "" },
  { heading: "State/Province", placeholder: "" },
];
